import { useQuery } from '@apollo/client';
import { useState } from 'react';
import {
  LmsUserCertificateListFilterInput,
  LmsUserCertificatesDocument,
  LmsUserCertificatesQuery,
} from 'src/graphql/generated/graphql';

interface UseUserCertificatesProps {
  filter?: LmsUserCertificateListFilterInput;
  pagination: {
    limit: number;
    page: number;
  };
}

export const useUserCertificates = ({
  filter,
  pagination,
}: UseUserCertificatesProps) => {
  const [totalCount, setTotalCount] = useState(0);

  const { data, loading } = useQuery<LmsUserCertificatesQuery>(
    LmsUserCertificatesDocument,
    {
      variables: {
        filter,
        pagination: {
          limit: pagination.limit || 10,
          offset: (pagination.page || 0) * pagination.limit,
        },
      },
      onCompleted: (data) =>
        setTotalCount(data.lmsUserCertificates.pagination.totalCount),
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-and-network',
    },
  );

  return {
    loading,
    data: data?.lmsUserCertificates.records || [],
    totalCount,
  };
};
